import * as React from 'react';
import {
  INTERNAL_SUPPORTED_EVENTS,
  PLUGIN_SUPPORTED_EVENTS,
} from '~/common/helpers';
import { useLogger } from '~/common/context';

export const usePluginEventHandlers = () => {
  const logger = useLogger();
  const getEventHandler = React.useCallback(
    (eventName: string): EventListener | null => {
      switch (eventName) {
        case PLUGIN_SUPPORTED_EVENTS.RELOAD_CUSTOMER:
          return () => {
            logger.info(
              `Plugin Event: ${PLUGIN_SUPPORTED_EVENTS.RELOAD_CUSTOMER} triggered`,
            );
            window.dispatchEvent(
              new CustomEvent(INTERNAL_SUPPORTED_EVENTS.RELOAD_CUSTOMER),
            );
          };
        case PLUGIN_SUPPORTED_EVENTS.NAVIGATE:
          return (event: Event) => {
            const { path } = (event as CustomEvent<{ path: string }>).detail;
            logger.info(
              `Plugin Event: ${PLUGIN_SUPPORTED_EVENTS.NAVIGATE} triggered`,
              { path },
            );
            window.dispatchEvent(
              new CustomEvent(INTERNAL_SUPPORTED_EVENTS.NAVIGATE, {
                detail: { path },
              }),
            );
          };
        case PLUGIN_SUPPORTED_EVENTS.UPDATE_LOCALE:
          return (event: Event) => {
            const { locale } = (event as CustomEvent<{ locale: string }>)
              .detail;
            logger.info(
              `Plugin Event: ${PLUGIN_SUPPORTED_EVENTS.UPDATE_LOCALE} triggered`,
              { locale },
            );
            window.dispatchEvent(
              new CustomEvent(INTERNAL_SUPPORTED_EVENTS.UPDATE_LOCALE, {
                detail: { locale },
              }),
            );
          };
        case PLUGIN_SUPPORTED_EVENTS.REAUTHENTICATE:
          return () => {
            logger.info(
              `Plugin Event: ${PLUGIN_SUPPORTED_EVENTS.REAUTHENTICATE} triggered`,
            );
            window.dispatchEvent(
              new CustomEvent(INTERNAL_SUPPORTED_EVENTS.REAUTHENTICATE),
            );
          };
        default:
          return null;
      }
    },
    [logger],
  );

  return {
    getEventHandler,
  };
};
